import { Outlet, useLocation, useMatch } from 'react-router-dom';
import MainRoute from '../../../../routes/MainRoute';
import { useNavigation } from '../../../../utils/customHooks';
import { Routes } from '../../../../routes/routes';
import { useEffect } from 'react';
import { useClientCompanyRegistrationContext } from './ClientCompanyRegistrationContext';
import { useLoadingContext } from '../../../contexts/LoadingContext';
import { LoadingSkeleton } from '../../../LoadingSkeleton';

function ClientMainWrapper() {
    const { pathname } = useLocation();
    const { isAdmin, registration, userInfo, isAdminAndUser } = useClientCompanyRegistrationContext();
    const isAdminPage = useMatch(`/${Routes.admin}/*`);
    const navigateTo = useNavigation();
    const { loading } = useLoadingContext();
    const navigateToAdmin = async () => {
        await navigateTo(Routes.admin_dashboard);
    };

    useEffect(() => {
        //Navigate to Adminpage only if: We are an admin and currently not on admin page
        if (!isAdminPage && isAdmin !== undefined && isAdmin && !isAdminAndUser) {
            navigateToAdmin();
        }
    }, [isAdmin, isAdminPage]);

    const renderContent = () => {
        if (loading && (userInfo === undefined || registration === undefined)) {
            return <LoadingSkeleton />;
        }
        // Admin detected, redirect pending → show immediate skeleton
        if (!isAdminPage && isAdmin === true && !isAdminAndUser) {
            return <LoadingSkeleton showSkeletonImmediately />;
        }
        // On admin pages
        if (isAdminPage || pathname !== '/') {
            return <Outlet />;
        }

        return <MainRoute />;
    };

    return renderContent();
}
export default ClientMainWrapper;
